<div class="list-container">
  <!-- Actions en lot -->
  <div *ngIf="hasSelection" class="batch-bar d-flex align-items-center p-2 mb-0">
    <span class="text-muted mr-3 font-weight-600">
      <i class="fas fa-check-circle text-primary mr-1"></i> {{ selectedItems.size }} selectionne(s)
    </span>
    <button *ngIf="listType === 'sent' || listType === 'waiting'" type="button"
      class="btn btn-sm btn-outline-danger mr-2 btn-action" (click)="batchMoveToTrash()" tooltip="Corbeille en lot">
      <i class="feather icon-trash-2 mr-1"></i> Corbeille
    </button>
    <button *ngIf="listType === 'trash'" type="button"
      class="btn btn-sm btn-outline-success mr-2 btn-action" (click)="batchRestore()" tooltip="Restaurer en lot">
      <i class="fas fa-redo mr-1"></i> Restaurer
    </button>
    <button *ngIf="listType === 'trash'" type="button"
      class="btn btn-sm btn-outline-danger mr-2 btn-action" (click)="batchDelete()" tooltip="Supprimer en lot">
      <i class="feather icon-trash-2 mr-1"></i> Supprimer
    </button>
  </div>

  <!-- Loading -->
  <div *ngIf="loading" class="text-center p-5">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only">Chargement...</span>
    </div>
    <p class="text-muted mt-2 mb-0">Chargement des messages...</p>
  </div>

  <!-- Etat vide -->
  <div *ngIf="!loading && messages && messages.length === 0" class="empty-state text-center p-5">
    <i class="fas fa-inbox text-muted" style="font-size: 3rem; opacity: 0.3;"></i>
    <p class="text-muted mt-3 mb-0">{{ emptyMessage }}</p>
  </div>

  <!-- Tableau de messages -->
  <div *ngIf="!loading && messages && messages.length > 0" class="table-responsive">
    <table class="table table-hover mb-0 message-table">
      <thead>
        <tr>
          <th style="width: 40px;" class="border-0">
            <div class="checkbox checkbox-primary checkbox-fill d-inline">
              <input type="checkbox" [checked]="allSelected" (change)="toggleSelectAll()" id="select-all-{{listType}}">
              <label for="select-all-{{listType}}" class="cr"></label>
            </div>
          </th>
          <th class="border-0">
            <i class="fas fa-user text-muted mr-1" style="font-size: 0.75rem;"></i> Destinataire
          </th>
          <th style="width: 35%;" class="border-0">
            <i class="fas fa-align-left text-muted mr-1" style="font-size: 0.75rem;"></i> Contenu
          </th>
          <th class="border-0">
            <i class="fas fa-calendar text-muted mr-1" style="font-size: 0.75rem;"></i> Date
          </th>
          <th class="border-0 text-center">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let send of messages" class="message-row" [class.selected]="isSelected(send.uuid)">
          <td>
            <div class="checkbox checkbox-primary checkbox-fill d-inline">
              <input type="checkbox" [checked]="isSelected(send.uuid)" (change)="toggleSelect(send.uuid)" [id]="'checkbox-' + send.uuid">
              <label [for]="'checkbox-' + send.uuid" class="cr"></label>
            </div>
          </td>
          <td>
            <div class="d-flex align-items-center">
              <div class="type-icon mr-2" [ngClass]="{'mail-icon': send?.type === 'MAIL', 'sms-icon': send?.type === 'SMS'}">
                <i [class]="send?.type === 'MAIL' ? 'fas fa-envelope' : 'fas fa-comment-alt'" style="font-size: 0.7rem;"></i>
              </div>
              <div>
                <span class="font-weight-600 text-dark">{{ getPersonaliseLabel(send) }}</span>
                <span class="badge badge-light ml-1">{{ send.destinataire?.length }}</span>
              </div>
            </div>
          </td>
          <td>
            <span class="text-muted content-preview">{{ truncateContent(send?.content) }}</span>
          </td>
          <td>
            <span class="text-muted" style="font-size: 0.825rem;">{{ send?.createdAt | date: "d MMM y, H:mm" : '' : 'fr-FR' }}</span>
          </td>
          <td class="text-center">
            <button type="button" class="btn btn-sm btn-icon-action btn-outline-secondary mr-1"
              tooltip="Detail" (click)="onShowDetail(send)">
              <i class="fas fa-eye"></i>
            </button>
            <button *ngIf="listType === 'waiting'" type="button" class="btn btn-sm btn-icon-action btn-outline-primary mr-1"
              tooltip="Renvoyer" (click)="onResend(send)">
              <i class="fas fa-redo"></i>
            </button>
            <button *ngIf="listType === 'sent' || listType === 'waiting'" type="button"
              class="btn btn-sm btn-icon-action btn-outline-danger mr-1"
              tooltip="Corbeille" (click)="onMoveToTrash(send)">
              <i class="feather icon-trash-2"></i>
            </button>
            <button *ngIf="listType === 'trash'" type="button" class="btn btn-sm btn-icon-action btn-outline-success mr-1"
              tooltip="Restaurer" (click)="onRestore(send)">
              <i class="fas fa-redo"></i>
            </button>
            <button *ngIf="listType === 'trash'" type="button" class="btn btn-sm btn-icon-action btn-outline-danger mr-1"
              tooltip="Supprimer" (click)="onDeletePermanent(send)">
              <i class="feather icon-trash-2"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
